/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Loading_Tip_BodyInputs */

const en_loading_tip_body = /** @type {(inputs: Loading_Tip_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Think of one thing you want to test first: who will use it, what they need to do, and what a successful result looks like. You can use this when reviewing the result.`)
};

const id_loading_tip_body = /** @type {(inputs: Loading_Tip_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pikirkan satu hal yang ingin kamu coba lebih dulu: siapa penggunanya, apa yang perlu mereka lakukan, dan seperti apa hasil yang benar. Gunakan ini saat meninjau hasilnya.`)
};

/**
* | output |
* | --- |
* | "Think of one thing you want to test first: who will use it, what they need to do, and what a successful result looks like. You can use this when reviewing th..." |
*
* @param {Loading_Tip_BodyInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const loading_tip_body = /** @type {((inputs?: Loading_Tip_BodyInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Loading_Tip_BodyInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_loading_tip_body(inputs)
	return en_loading_tip_body(inputs)
});